<div class = "reusable-form-component">
  <ion-label class = "label">{{ labelText }}</ion-label>
  <ion-radio-group [(ngModel)] = "selectedOption" (ionChange) = "handleChange(selectedOption)">
    <ion-item *ngFor = "let option of options" class = "hide-border-bottom">
      <ion-radio [value] = "option.value"></ion-radio>
      <ion-label class = "small-font non-italic-label">{{ option.label }}</ion-label>
    </ion-item>
  </ion-radio-group>
</div>